import { REPORT_GROUPS, reportGroupSchema, type ReportKey } from "@commerce-os/contracts";
import { createFileRoute, notFound } from "@tanstack/react-router";

import { ReportPage } from "../../../features/reports/report-page";
import { reportSearch } from "../../../features/reports/report-search";

export const Route = createFileRoute("/_app/reports/$group/$report")({
  validateSearch: reportSearch,
  beforeLoad: ({ params }) => {
    const group = reportGroupSchema.safeParse(params.group);
    if (!group.success || !(REPORT_GROUPS[group.data] as readonly string[]).includes(params.report))
      throw notFound();
  },
  component: ReportRoute,
});

function ReportRoute() {
  const { group, report } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReportPage
      key={`${group}/${report}`}
      group={reportGroupSchema.parse(group)}
      // `beforeLoad` checked the report belongs to the group.
      report={report as ReportKey}
      search={search}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
